export default __webpack_public_path__ + "static/Mont-Thin-b630a1b54cddf70887ff75e814b90c73.otf";